import {useContext, useEffect, type ReactNode} from 'react';
import {createPortal} from 'react-dom';
import {CaptureDockContext} from './captureDockContext';

type CaptureDockProps = {
  children: ReactNode;
  /** Classes for the host's strip, not for the children — see useCaptureDock. */
  className?: string;
};

export function CaptureDock({children, className}: CaptureDockProps) {
  const dock = useContext(CaptureDockContext);
  const acquire = dock?.acquire;
  const release = dock?.release;

  useEffect(() => {
    if (!acquire || !release) return;
    acquire(className);
    return () => release(className);
  }, [acquire, release, className]);

  if (!dock?.container) return <>{children}</>;

  return createPortal(children, dock.container);
}
